import styled from 'styled-components';

import {
  fontFamilyPrimary,
  colorGrey400,
  colorBlack900,
  colorPrimary,
  colorSecondary,
  colorWhite,
  colorAccentLighten95,
  mediaQueryMobileLargeMin,
} from 'styles';

import { comments } from 'constants/currency';

import { Wrapper } from 'components/CurrencyExchangeTable/styles';

export const WrapperTimeLine = styled(Wrapper)``;

export const Container = styled.div`
  width: 100%;
  max-height: 540px;
  overflow-y: auto;
  margin-top: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    max-height: 340px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const ItemContent = styled.div`
  flex: 1;
  padding: 16px;
  border-radius: 8px;
  background-color: ${colorAccentLighten95};
  margin-bottom: 8px;
`;

export const ItemContainer = styled.div`
  font-family: ${fontFamilyPrimary};
  display: flex;
  font-size: 14px;
  line-height: 20px;
  padding-left: 15px;
  margin-left: 6px;
  border-left: 2px solid
    ${({ theme }) =>
      theme.status === comments.ACTIVE ? colorPrimary : colorSecondary};
  position: relative;

  &:after {
    content: ' ';
    position: absolute;
    width: 14px;
    height: 14px;
    left: -10px;
    top: 15px;
    background-color: ${({ theme }) =>
      theme.status === comments.ACTIVE ? colorPrimary : colorSecondary};
    border-radius: 50%;
    border: 2px solid ${colorWhite};
    box-sizing: content-box;
  }

  &:last-child {
    ${ItemContent} {
      margin-bottom: 0;
    }
  }

  @media all and ${mediaQueryMobileLargeMin} {
    padding-left: 23px;
  }
`;

export const Time = styled.div`
  color: ${colorGrey400};
  font-size: 13px;
`;

export const Currency = styled.div`
  font-weight: 700;
  color: ${colorBlack900};
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    padding: 0 4px;
    margin-top: -2px;
  }
`;

export const PriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 16px;
  margin-left: -1px;
  font-size: 14px;

  &:last-of-type {
    align-items: flex-end;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;

    &:last-of-type {
      align-items: center;
    }
  }
`;

export const Description = styled.div`
  color: ${colorBlack900};
  margin-top: 8px;
  font-size: 14px;
`;

export const Open = styled.div`
  color: ${colorPrimary};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;
export const Closed = styled.div`
  color: ${colorSecondary};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-left: 4px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;

  svg {
    margin-top: ${({ fall }) => (fall ? '2px' : '1px')};
  }
`;

export const Diff = styled.div`
  font-size: 11px;
  color: ${colorGrey400};
  line-height: 9px;
  margin-left: 2px;
  font-weight: 400;
`;
